import { useEffect, useState } from "react";
import { Link,useParams } from "react-router-dom";
import { supabase } from "../lib/supabaseClient.ts";
// import { useParams } from "react-router-dom/cjs/react-router-dom.min.js";
const getImageUrl = (path) =>
  `https://aujdasturxpqlzqjbztf.supabase.co/storage/v1/object/public/animalia/${path}`;
// const products = [
//   { id: 1, name: "Brit Care Hypoallergénique", category: "Alimentation", subcategory: "Croquette", priceRange: "65,000DT – 269,000DT", image: "img/product/britcare.jpg" },
//   { id: 2, name: "Brit Care Mini Sans Céréales", category: "Alimentation", subcategory: "Croquette", priceRange: "17,000DT – 69,000DT", image: "img/product/mini.png" },
//   { id: 3, name: "Brit Fresh", category: "Alimentation", subcategory: "Croquette", priceRange: "45,000DT – 210,000DT", image: "img/product/fresh.png" },
//   { id: 4, name: "Brit Premium by Nature", category: "Alimentation", subcategory: "Croquette", priceRange: "45,000DT – 220,000DT", image: "img/product/premium.png" },
//   { id: 5, name: "BROKATON CHIEN", category: "Alimentation", subcategory: "Croquette", priceRange: "171,000DT – 242,000DT", image: "img/product/brokaton.jpg" },
//   { id: 6, name: "COTAGRO CHIEN", category: "Alimentation", subcategory: "Croquette", priceRange: "198,000DT – 210,000DT", image: "img/product/cotagroadult.jpg" },
//   { id: 7, name: "DOG VET SOLUTION", category: "Alimentation", subcategory: "Croquette", priceRange: "93,000DT – 395,000DT", image: "img/product/dogvet.png" },
//   { id: 8, name: "Royal Canin Maxi", category: "Alimentation", subcategory: "Croquette", priceRange: "135,000DT – 355,000DT", image: "img/product/maxi.jpg" },
//   { id: 9, name: "Royal Canin Medium", category: "Alimentation", subcategory: "Croquette", priceRange: "140,000DT – 355,000DT", image: "img/product/medium.jpg" },
//   { id: 10, name: "Royal Canin Mini", category: "Alimentation", subcategory: "Croquette", priceRange: "95,000DT – 100,000DT", image: "img/product/miniiroyale.jpg" }
// ];


function AdoptionShop() {
      const { id } = useParams();
  
  const [products, setProducts] = useState([]);
  const [section, setSection] = useState(null);
  const [isMobile, setIsMobile] = useState(false);


  
    const [sectionMeta, setSectionMeta] = useState(null);
    useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

useEffect(() => {
  const fetchBestSellers = async () => {
    // Fetch section meta from best_sellers_section table
    const { data: section, error: error1 } = await supabase
      .from("best_sellers_section")
      .select("*")
      .maybeSingle();

    // Fetch products where best = true
    const { data: products, error: error2 } = await supabase
      .from("products")
      .select("*")
      .eq("best", true);

    if (error1) {
      console.error("Error fetching section meta:", error1);
    } else if (section) {
      setSectionMeta(section);
    }

    if (error2) {
      console.error("Error fetching products:", error2);
    } else if (products) {
      setProducts(products);
    }
  };

  fetchBestSellers();
}, []);


  const filteredProducts = products
    .slice(0, 6);
  
  return (
        <section className="new-arrivals py-5"  style={{
  transform: isMobile ? "translateY(-170px)" : "none", // shift upward on mobile
}}>
  <div className="container">
    <div className="row justify-content-center">
      <div className="col-xl-7 col-lg-9">
        <div className="section-title text-center mb-65">
          <h5 className="sub-title" style={{ fontSize: isMobile ? "16px" : "18px" }}>
            {sectionMeta?.subtitle || "Nouveaux produits"}
          </h5>
          <h2 className="title" style={{
            fontSize: isMobile ? "24px" : "34px",
            fontWeight: "700",
          }}>
            {sectionMeta?.title || "Découvrez nos nouveautés chez Animalia+"}
          </h2>
          <p style={{
            fontSize: isMobile ? "12px" : "14px",
            textAlign: "center",
            maxWidth: "500px",
            margin: "auto",
            lineHeight: "1.5",
          }}>
            {sectionMeta?.description || "Explorez les derniers produits ajoutés à notre boutique. Que ce soit pour chats, chiens ou pour le jeu, trouvez ce qu’il vous faut."}
          </p>
        </div>
      </div>
    </div>

    {/* Card Wrapper */}
    <div className="scroll-container" style={{
      display: "flex",
      flexDirection: "row",
      overflowX: isMobile ? "auto" : "unset", // Allow horizontal scrolling on mobile
      overflowY: "hidden", // Prevent vertical scrolling
      gap: isMobile ? "1rem" : "2.5rem",
      scrollSnapType: isMobile ? "x mandatory" : "none",
      padding: isMobile ? "0 16px" : "0",
      margin: isMobile ? "0" : "0 100px",
      rowGap: isMobile ? "0" : "60px",
      flexWrap: isMobile ? "nowrap" : "wrap", // Prevent wrapping on mobile
      justifyContent: isMobile ? "flex-start" : "center",

      // Hide scrollbar cross-browser
      scrollbarWidth: "none", // Firefox
      msOverflowStyle: "none", // IE 10+
    }}>
      {filteredProducts.map((product, index) => (
        <div key={product.id} className="adoption-shop-item" style={{
          scrollSnapAlign: isMobile ? "start" : "unset",
          flex: isMobile ? "0 0 72%" : "0 0 calc(33.33% - 2.5rem)", // 3 per row on web
          width: isMobile ? "auto" : "100%", // full width within flex-basis
          backgroundColor: "#F4F1EA",
          borderRadius: "4px",
          padding: "10px",
          height: "303px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}>
          <Link to={`/shop-details/${product.id}`}>
            {/* Image */}
            <div className="adoption-shop-thumb" style={{
              width: "100%",
              height: "170px",
              overflow: "hidden",
              marginBottom: "8px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "relative",
              objectFit: "contain"
            }}>
              <img
                key={product.id}
                src={product.image}
                alt={product.name}
                style={{
                  width: product.id === 3 ? "60%" : "90%",
                  height: isMobile ? "100%" : "90%",
                  objectFit: "contain",
                  backgroundColor: "transparent",
                  transform: isMobile && index === 0 ? "translateX(10%)" : "none",
                }}
              />
            </div>
          </Link>

          {/* Text */}
          <div className="adoption-shop-content" style={{
            textAlign: "center",
            width: "90%",
            height: "50%",
            minHeight: "80px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            marginLeft: "15px",
            transform: "translateY(67px)",
          }}>
            <h6 className="title" style={{
              fontSize: isMobile ? "14px" : "16px",
              marginBottom: "6px",
              color: "black",
              minHeight: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}>
              <Link to={`/shop-details/${product.id}`}>{product.name}</Link>
            </h6>

            <div className="adoption-meta">
              <ul></ul>
            </div>

{product.price_range && (
  <div className="adoption-rating">
    <ul style={{ padding: 0, margin: 0, listStyle: "none" }}>
      <li
        className="price"
        style={{
          fontSize: "15px",
          color: "#ff41b4",
          fontWeight: "bold",
          textAlign: "right",
          transform: isMobile
            ? "translateX(35px)"
            : "translateX(45px)",
        }}
      >
        <span>
          {new Intl.NumberFormat("fr-FR", {
            minimumFractionDigits: 3,
            maximumFractionDigits: 3,
          }).format(parseFloat(product.price_range))}{" "}
          DT
        </span>
      </li>
    </ul>
  </div>
)}

          </div>
        </div>
      ))}

      {filteredProducts.length === 0 && (
        <div className="col-12 text-center">
          <p className="text-muted">Aucun produit trouvé.</p>
        </div>
      )}
    </div>
  </div>
</section>



);

}

export default AdoptionShop;
